<template>
  <div id="home">
    <div class="home_banner">
      <el-carousel
        class="bannerStyle"
        :interval="1000000"
        arrow="always"
        height="960px"
      >
        <el-carousel-item>
          <img src="../../src/assets/images/banner.jpg" alt="" srcset="" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../src/assets/images/banner.jpg" alt="" srcset="" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../src/assets/images/banner.jpg" alt="" srcset="" />
        </el-carousel-item>
      </el-carousel>
      <p class="homeBanner_title text_center">
        守正创新 踔厉奋发 笃行致远 连通世界
      </p>
      <div class="flex flex_b_t_w homeBanner_list">
        <div class="flex flex_left alian_center">
          <img class="mx-4" src="../assets/images/icon-banner-1.png" />
          <p class="text d-flex flex-column">
            <span class="number">583,799</span>
            <span class="num_text">实时政策数据</span>
          </p>
        </div>
        <div class="flex flex_left alian_center">
          <img class="mx-5" src="../assets/images/icon-banner-2.png" />
          <p class="text d-flex flex-column">
            <span class="number">243,840</span>
            <span class="num_text">政策基础数据</span>
          </p>
        </div>
        <div class="flex flex_left alian_center">
          <img class="mx-6" src="../assets/images/icon-banner-3.png" />
          <p class="text d-flex flex-column">
            <span class="number">1000+</span>
            <span class="num_text">覆盖行业细类</span>
          </p>
        </div>
        <div class="flex flex_left alian_center">
          <img class="mx-7" src="../assets/images/icon-banner-4.png" />
          <p class="text d-flex flex-column">
            <span class="number">3000+</span>
            <span class="num_text">服务企业机构</span>
          </p>
        </div>
      </div>
      <div class="home_popup"></div>
    </div>
    <div class="home_one flex flex_b_t_w web_maxWitch web_minWitch">
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-1.png" />
        </div>
        <p class="title">商贸投资服务</p>
      </div>
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-2.png" />
        </div>
        <p class="title">金融</p>
      </div>
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-3.png" />
        </div>
        <p class="title">法务</p>
      </div>
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-4.png" />
        </div>
        <p class="title">物流</p>
      </div>
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-5.png" />
        </div>
        <p class="title">数字信息</p>
      </div>
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-6.png" />
        </div>
        <p class="title">科创孵化</p>
      </div>
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-7.png" />
        </div>
        <p class="title">农经合作</p>
      </div>
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-8.png" />
        </div>
        <p class="title">文旅合作</p>
      </div>
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-9.png" />
        </div>
        <p class="title">人才服务</p>
      </div>
      <div class="col_home">
        <div class="icon">
          <img class="image" src="../assets/images/icon-service-10.png" />
        </div>
        <p class="title">科技组织</p>
      </div>
    </div>
    <div class="home_two web_maxWitch web_minWitch">
      <p class="homeTwo_title text_center">中心动态</p>
      <p class="homeTwo_text text_center">一起来了解最新行业新闻动态吧！</p>

      <div class="homeTwo_banner flex flex_b_t_w alian_center">
        <div
          class="jianTou jianLeft flex flex_center alian_center"
          @click="arrowClick('left')"
        >
          <img src="../../src/assets/images/jiantou.png" alt="" />
        </div>
        <el-carousel
          indicator-position="none"
          :interval="20000"
          arrow="never"
          height="475px"
          ref="cardShow"
          style="width: 1380px; margin: 0 auto"
        >
          <el-carousel-item
            class="homeTwo_slide_item flex flex_left"
            v-for="item in 3"
            :key="item"
            style="display: flex"
          >
            <div class="homeTwo_slide">
              <img
                class="homeTwo_slide_image"
                src="../assets/images/image-news-1.jpg"
              />
              <p class="homeTwo_slide_title">
                上海交大医学院海南国际医学中心落户乐城
              </p>
              <p class="homeTwo_slide_date">2022年1月7日</p>
              <div class="homeTwo_slide_intro">
                4月24日上午，中国—东盟经贸中心在广西自贸试验区南宁片区正式揭牌运营。作为中国广西自由贸易试验区的重大标志性项目，中国—东盟经贸中心将有力推进中国与东盟乃至RCEP国家的国际...
              </div>
              <a class="homeTwo_slide_more" href="#">阅读全文 ></a>
            </div>
            <div class="homeTwo_slide">
              <img
                class="homeTwo_slide_image"
                src="../assets/images/image-news-2.jpg"
              />
              <p class="homeTwo_slide_title">
                上海交大医学院海南国际医学中心落户乐城
              </p>
              <p class="homeTwo_slide_date">2022年1月7日</p>
              <div class="homeTwo_slide_intro">
                4月24日上午，中国—东盟经贸中心在广西自贸试验区南宁片区正式揭牌运营。作为中国广西自由贸易试验区的重大标志性项目，中国—东盟经贸中心将有力推进中国与东盟乃至RCEP国家的国际...
              </div>
              <a class="homeTwo_slide_more" href="#">阅读全文 ></a>
            </div>
            <div class="homeTwo_slide">
              <img
                class="homeTwo_slide_image"
                src="../assets/images/image-news-3.jpg"
              />
              <p class="homeTwo_slide_title">
                上海交大医学院海南国际医学中心落户乐城
              </p>
              <p class="homeTwo_slide_date">2022年1月7日</p>
              <div class="homeTwo_slide_intro">
                4月24日上午，中国—东盟经贸中心在广西自贸试验区南宁片区正式揭牌运营。作为中国广西自由贸易试验区的重大标志性项目，中国—东盟经贸中心将有力推进中国与东盟乃至RCEP国家的国际...
              </div>
              <a class="homeTwo_slide_more" href="#">阅读全文 ></a>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div
          class="jianTou jianRight flex flex_center alian_center"
          @click="arrowClick('right')"
        >
          <img src="../../src/assets/images/jiantou.png" alt="" />
        </div>
      </div>

      <div class="homeTwo_more text_center">查看更多</div>
    </div>
    <div
      class="home_three web_maxWitch web_minWitch"
      :style="'background: #f5f5f5 url(' + imgs + ') 100% 400% no-repeat;'"
    >
      <p class="homeTwo_title text_center">会议活动</p>
      <p class="homeTwo_text text_center">一起来了解最新会议活动吧！</p>
      <div class="homeThree_container">
        <div class="flex flex_left homeThree_btn">
          <div :class="type == 0 ? 'threeActive' : ''" @click="homeThreeBtn(0)">
            所有活动
          </div>
          <div :class="type == 1 ? 'threeActive' : ''" @click="homeThreeBtn(1)">
            国内活动
          </div>
          <div :class="type == 2 ? 'threeActive' : ''" @click="homeThreeBtn(2)">
            国外活动
          </div>
        </div>
        <div class="homeThree_shijian flex flex_left">
          <div class="shijian_left"></div>
          <div class="shijian_right">
            <p>即将举行的会议活动</p>
            <div style="overflow: auto; width: 764px; height: 320px">
              <div class="shijian_list" v-for="item in 8" :key="item">
                <div class="flex flex_left alian_center">
                  <div
                    class="shijian_date"
                    :class="item == 1 ? 'guoWai' : 'guoNei'"
                  >
                    <p class="text_center">26</p>
                    <p class="text_center">2022-3</p>
                  </div>
                  <div class="shijian_text" @click="meetingBtn">
                    <div class="flex flex_left">
                      <p class="shijian_address">南宁</p>
                      <p>2021年12月26日 - 2022年1月25日</p>
                    </div>
                    <p class="text_wenben">
                      中小企进军大湾区的个案分享及支援服务网上座谈会
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="homeTwo_more text_center">查看更多</div>
    </div>
    <div class="home_four web_maxWitch web_minWitch">
      <p class="homeTwo_title text_center">RCEP成员国</p>
      <p class="homeTwo_text text_center">一起来了解RCEP成员国所有成员吧！</p>
      <div class="homeFour_container flex flex_left flex_warp">
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 1 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-1.jpg" />
          <p class="title">文莱</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 2 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-2.jpg" />
          <p class="title">柬埔寨</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 3 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-3.jpg" />
          <p class="title">中国</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 4 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-4.jpg" />
          <p class="title">印度尼西亚</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 5 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-5.jpg" />
          <p class="title">老挝</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 6 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-6.jpg" />
          <p class="title">马来西亚</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 7 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-7.jpg" />
          <p class="title">缅甸</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 8 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-8.jpg" />
          <p class="title">菲律宾</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 9 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-9.jpg" />
          <p class="title">新加坡</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 10 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-10.jpg" />
          <p class="title">泰国</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 11 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-11.jpg" />
          <p class="title">越南</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 12 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-12.jpg" />
          <p class="title">日本</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 13 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-13.jpg" />
          <p class="title">韩国</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 14 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-14.jpg" />
          <p class="title">澳大利亚</p>
        </router-link>
        <router-link
          :to="{ path: '/RCEPmemberState', query: { type: 15 } }"
          class="homeFour_col"
        >
          <img class="image" src="../assets/images/country-15.jpg" />
          <p class="title">新西兰</p>
        </router-link>
      </div>
    </div>
    <!-- <div
      class="home_five web_maxWitch web_minWitch"
      :style="'background-image:url(' + img + ')'"
    >
      <div class="homeFive_title text_center">政策查询</div>
      <div class="homeFive_container">
        <div class="hopmeFive_input flex flex_left alian_center">
          <i class="hopmeFive_icon flex flex_center alian_center"
            ><img src="../assets/images/icon-inquiry-search.png"
          /></i>
          <input class="" placeholder="请输入您想查询的政策" />
          <button class="text_center">查询</button>
        </div>
        <div class="hopmeFive_intro">
          <span>常用业务 :</span>
          <a class="hopmeFive_link" href="">舆情检测</a>
          <a class="hopmeFive_link" href="">政策查询</a>
        </div>
      </div>
    </div> -->
    <div
      class="home_five web_maxWitch web_minWitch"
      :style="'background-image:url(' + img + ')'"
    >
      <div class="homeFive_title text_center">政策查询</div>
      <div class="homeFive_container">
        <div class="hopmeFive_input flex flex_left alian_center">
          <i class="hopmeFive_icon flex flex_center alian_center"
            ><img src="../assets/images/icon-inquiry-search.png"
          /></i>
          <input class="" placeholder="请输入您想查询的政策" />
          <button class="text_center">查询</button>
        </div>
        <div class="hopmeFive_intro">
          <span>常用业务 :</span>
          <a class="hopmeFive_link" href="">舆情检测</a>
          <a class="hopmeFive_link" href="">政策查询</a>
        </div>
      </div>
    </div>

    <div class="home_six web_maxWitch web_minWitch">
      <p class="home_six_title text_center">友情链接</p>
      <div class="flex flex_left flex_warp homeSix_list">
        <div v-for="item in 8" :key="item">
          <img
            src="../assets/images/image-links-1.jpg"
            class="homeSix_img"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
#home {
  padding-top: 134px;
}
.homeThree_shijian {
  width: 1320px;
  height: 360px;
  margin-top: 40px;
  padding: 32px 0;
  background-color: #ffffff;
}
.shijian_left {
  width: 500px;
  height: 360px;
}
.shijian_right {
  width: 796px;
  height: 360px;
}
.shijian_right > p {
  font-size: 18px;
  color: #212529;
  font-weight: bold;
  margin-bottom: 8px;
}
.shijian_list {
  padding: 9px 0;
}
.shijian_address {
  font-size: 16px;
  color: #212529;
  font-weight: 700;
  padding-right: 11px;
  border-right: 1px solid #dadada;
  margin-right: 11px;
}
.text_wenben {
  margin-top: 6px;
}
.shijian_date {
  width: 47px;
  height: 45px;
  padding: 8px;
  border-radius: 2px;
}
.guoNei {
  background-color: #cd9a4c;
}
.guoWai {
  background-color: #385d86;
}
.shijian_text {
  margin-left: 16px;
}
.shijian_date p:nth-child(1) {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
}
.shijian_date p:nth-child(2) {
  font-size: 12px;
  color: #fff;
}
.home_three {
  height: 987px;
  margin: 0 auto;
}
.homeThree_container {
  width: 1320px;
  height: 514px;
  margin: 0 auto;
}
.homeThree_btn {
  width: 408px;
  height: 50px;
  background-color: #fff;
  margin: 0 auto;
  border-radius: 2px;
}
.homeThree_btn div {
  width: 136px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #212529;
  border-radius: 2px;
}
.homeThree_btn div.threeActive {
  background-color: #cd9a4c;
  color: #ffffff;
  font-weight: bold;
}
.home_four {
  height: 951px;
  padding-bottom: 48px;
}
.homeFour_container {
  width: 1320px;
  margin: 0 auto;
}
.homeFour_col {
  width: 240px;
  padding: 0 12px;
}
.homeFour_col img {
  width: 240px;
  height: 160px;
}
.homeFour_col p {
  font-size: 16px;
  color: #212529;
  text-align: center;
  padding: 16px 0 24px 0;
  margin-bottom: 16px;
}

.home_five {
  height: 300px;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 96px;
}
.homeFive_title {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  padding-top: 80px;
}
.homeFive_container {
  width: 1320px;
  margin: 40px auto 0;
}
.hopmeFive_input {
  width: 745px;
  height: 64px;
  background-color: #ffffff;
  margin: 0 auto;
}
.hopmeFive_intro {
  width: 745px;
  margin: 32px auto 0;
  font-size: 16px;
  color: #ffffff;
}
.hopmeFive_intro a {
  font-size: 16px;
  color: #ffffff;
}
.hopmeFive_link {
  margin-left: 24px;
}
.hopmeFive_input .hopmeFive_icon {
  width: 49px;
  height: 35px;
  margin-left: 16px;
}
.hopmeFive_icon img {
  width: 33px;
  height: 29px;
}
.hopmeFive_input input {
  width: 552px;
  height: 64px;
  font-size: 16px;
  color: #333333;
  border: 0;
  padding: 0 16px;
  box-sizing: border-box;
}
.hopmeFive_input button {
  width: 144px;
  height: 64px;
  line-height: 64px;
  font-size: 16px;
  background-color: #cd9a4c;
  color: #fff;
}

// .home_five {
//   height: 300px;
//   background-repeat: no-repeat;
//   background-size: cover;
//   padding-bottom: 96px;
// }
// .homeFive_title {
//   font-size: 40px;
//   font-weight: 700;
//   color: #fff;
//   padding-top: 80px;
// }
// .homeFive_container {
//   width: 1320px;
//   margin: 40px auto 0;
// }
// .hopmeFive_input {
//   width: 745px;
//   height: 64px;
//   background-color: #ffffff;
//   margin: 0 auto;
// }
// .hopmeFive_intro {
//   width: 745px;
//   margin: 32px auto 0;
//   font-size: 16px;
//   color: #ffffff;
// }
// .hopmeFive_intro a {
//   font-size: 16px;
//   color: #ffffff;
// }
// .hopmeFive_link {
//   margin-left: 24px;
// }
// .hopmeFive_input .hopmeFive_icon {
//   width: 49px;
//   height: 35px;
//   margin-left: 16px;
// }
// .hopmeFive_icon img {
//   width: 33px;
//   height: 29px;
// }
// .hopmeFive_input input {
//   width: 552px;
//   height: 64px;
//   font-size: 16px;
//   color: #333333;
//   border: 0;
//   padding: 0 16px;
//   box-sizing: border-box;
// }
// .hopmeFive_input button {
//   width: 144px;
//   height: 64px;
//   line-height: 64px;
//   font-size: 16px;
//   background-color: #cd9a4c;
//   color: #fff;
// }

.home_six {
  height: 436px;
  padding-bottom: 96px;
}
.home_six_title {
  font-size: 40px;
  font-weight: 700;
  color: #212529;
  padding-top: 80px;
}
.homeSix_list {
  width: 1320px;
  margin: 48px auto 0;
  height: 234px;
  overflow: hidden;
}
.homeSix_list > div:nth-child(4n) {
  border-right: 0;
}
.homeSix_list > div {
  padding: 8px 32px;
  border-right: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
}
.border_right {
  border-right: 1px solid #e2e2e2;
}
.border_bottom {
  border-bottom: 1px solid #e2e2e2;
}
.homeSix_img {
  width: 265px;
  height: 101px;
}
.home_two {
  height: 948px;
  background-color: #ffffff;
  margin: 0 auto;
}
.homeTwo_title {
  font-size: 40px;
  font-weight: 700;
  color: #212529;
  padding-top: 80px;
}
.homeTwo_text {
  font-size: 18px;
  color: #5f5d5d;
  margin: 16px 0 48px 0;
}
.homeTwo_banner {
  width: 1592px;
  height: 475px;
  margin: 0 auto;
}

.homeTwo_banner .el-carousel__item {
  background-color: #fff;
}

// .homeTwo_banner .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }
.jianTou {
  width: 50px;
  height: 70px;
  background-color: rgba(0, 0, 0, 0.5);
}
.jianTou img {
  width: 24px;
  height: 24px;
}
.jianLeft {
  margin-right: 54px;
}
// .jianRight {
//   margin-left: 54px;
// }
.jianRight img {
  transform: rotateY(180deg);
}
.homeTwo_slide_item > div {
  width: 405px;
  height: 475px;
  margin-right: 60px;
}
.homeTwo_slide_image {
  width: 405px;
  height: 256px;
}
.homeTwo_slide_title {
  font-size: 18px;
  color: #212529;
  font-weight: 700;
  padding-top: 24px;
  margin-bottom: 16px;
}
.homeTwo_slide_date {
  font-size: 14px;
  color: #5f5d5d;
  margin-bottom: 16px;
}
.homeTwo_slide_intro {
  font-size: 14px;
  color: #5f5d5d;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.homeTwo_slide_more {
  font-size: 14px;
  color: #cb9334;
  padding-top: 16px;
  display: inline-block;
}

/deep/ .homeTwo .el-carousel .el-carousel__container .el-carousel__item {
  display: flex;
}
.homeTwo_more {
  width: 264px;
  line-height: 50px;
  padding: 0 96px;
  background-color: #cb9334;
  border-radius: 2px;
  font-size: 18px;
  color: #ffffff;
  margin: 96px auto;
  box-sizing: border-box;
}
.home_one {
  height: 102px;
  padding: 0 15% 0 18%;
  box-sizing: border-box;
  background-color: #f5f5f5;
}
.home_one .title {
  font-size: 16px;
  color: #212529;
  text-align: center;
  margin-top: 7px;
}
.home_one .icon {
  width: 40px;
  height: 40px;
  margin: 16px auto 0;
  overflow: hidden;
}
.home_one image {
  width: 40px;
  height: 80px;
}
.home_one .col_home {
  width: 136px;
  height: 102px;
  padding: 0 10px;
  box-sizing: border-box;
}
.col_home:hover {
  background-color: #cb9334;
}
.col_home:hover .image {
  margin-top: -40px;
}
.col_home:hover .title {
  color: #ffffff;
}

.home_banner {
  position: relative;
}
.homeBanner_title {
  position: absolute;
  width: 100%;
  top: 355px;
  font-size: 64px;
  font-weight: bold;
  color: #ffffff;
  z-index: 50;
}
.homeBanner_list {
  position: absolute;
  width: 100%;
  height: 144px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0 18%;
  box-sizing: border-box;
  bottom: 0;
  z-index: 55;
}
.homeBanner_list .mx-4 {
  width: 47px;
  height: 44px;
  margin: 0 24px;
}
.homeBanner_list .mx-5 {
  width: 36px;
  height: 50px;
  margin: 0 24px;
}
.homeBanner_list .mx-6 {
  width: 50px;
  height: 50px;
  margin: 0 24px;
}
.homeBanner_list .mx-7 {
  width: 36px;
  height: 50px;
  margin: 0 24px;
}
.homeBanner_list span {
  display: block;
}
.homeBanner_list .number {
  font-size: 30px;
  font-weight: bold;
  color: #ffffff;
}
.homeBanner_list .num_text {
  font-size: 18px;
  color: #ffffff;
}
.home_banner .el-carousel__container,
.home_banner .el-carousel__item,
.home_banner .el-carousel__item img {
  max-width: 1920px;
  min-width: 1380;
  height: 960px;
}
#home .home_popup {
  position: absolute;
  width: 100%;
  height: 960px;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 20;
  top: 0;
}
/deep/ .home_banner .el-carousel--horizontal .el-carousel__indicators {
  display: flex;
  align-items: center;
  bottom: 300px;
  z-index: 30;
}
/deep/ .home_banner .el-carousel__indicator--horizontal {
  margin-left: 10px;
  width: 25px;
  height: 25px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
/deep/ .home_banner .el-carousel__indicator--horizontal.is-active {
  border: 1px solid #ffffff;
}
/deep/ .home_banner .el-carousel__indicator--horizontal .el-carousel__button {
  width: 7px;
  height: 7px;
  background-color: #ffffff;
  border-radius: 50%;
}
/deep/ .home_banner .el-carousel__indicator--horizontal .el-carousel__button {
  width: 7px;
  height: 7px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 1;
}
</style>
<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'


export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  data() {
    return {
      img: require('../../src/assets/images/inquiry-bg.jpg'),
      imgs: require('../../src/assets/images/meeting-bg.png'),
      type: 0

    }
  },
  methods: {
    meetingBtn() {

    }
  }

}
</script>
